import React, { useEffect, useMemo, useState } from "react"
import PropTypes from "prop-types"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import TableContainer from "../../../components/Common/TableContainer"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Input,
  UncontrolledTooltip,
  FormGroup,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Label,
  FormFeedback,
  InputGroup,
} from "reactstrap"
import * as Yup from "yup"
import jsPDF from "jspdf"
// import { InvoiceHtml } from "pages/Reports/Booking/invoicePDF"
import { UserInvoicePdf } from "./UserInvoicePDF"
// import { font } from "pages/Reports/Booking/font"
import { UserFont } from "./UserFont"
import DeleteModel from "common/deleteModel/deleteModel"
import toast from "react-hot-toast"
import { dateFormat } from "pages/Common"
import useApi from "common/ApiMiddlewere"
import { routes } from "routes/path"
import ErrorModel from "common/errorModel/errorModel"
import breadcrumbs from "../../../common/Breadcrumbs"
import { useFormik } from "formik"
import SubscriptionModel from "components/Common/SubscriptionModel"
import appConfig from "Api/app.config"
import { encryptData, decryptData } from "common/encrptDecryptforlogin"

function DatatableTables() {
  const { deleteApi, postApi, putApi, getApi } = useApi()
  const navigate = useNavigate()
  let { pathname } = useLocation()
  const [screeLoad, setscreeLoad] = useState(false)
  const [tableData, setTableData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [userId, setUserId] = useState(0)
  const [username, setUsername] = useState("")
  const [rolename, setRolename] = useState("")
  const [modal, setModal] = useState(false)
  const [modal1, setModal1] = useState(false)
  const [modal2, setModal2] = useState(false)
  const [passwordShow, setPasswordShow] = useState(false)
  const [TotalRecords, setTotalRecords] = useState(0.0)
  const [searchText, setSearchText] = useState("")
  const [rowsPerPage, setRowsPerPage] = useState(20)
  const [displayStart, setDisplayStart] = useState(1)
  const [adminId, setadminId] = useState(JSON.parse(localStorage.getItem("authUser")).Id)
  const [isMobile, setisMobile] = useState(window.innerWidth < 768)

  // filterData for users
  const filterData = textFilter => {
    // setSearchText(textFilter)
  }

  const pagePerSize = (pageSize, pagePerIndex, serchValue) => {
    setDisplayStart(pagePerIndex * pageSize - pageSize + 1)
    setSearchText(serchValue == undefined ? "" : serchValue)
    setRowsPerPage(pageSize)
  }
  const userList = () => {
    setscreeLoad(true)
    postApi("User/user-list", {
      displayStart: displayStart,
      pageSize: rowsPerPage,
      searchText: searchText.trim(),
      sortColumn: "",
      sortOrder: "asc",
    }).then(({ data, status }) => {
      if (status === 200) {
        setTableData(data.UserList)
        setTotalRecords(data.TotalRecords)
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
      setscreeLoad(false)
    })
  }

  useEffect(() => {
    async function UserDetails() {
      const {
        data: { RoleName },
      } = await getApi(`User/user-details?id=-1`)
      setRolename(RoleName)
    }
    UserDetails()
  }, [])

  // userList useEffect
  useEffect(() => {
    userList()
  }, [rowsPerPage, searchText, displayStart])


  // user delete handler
  const handleDelete = id => {
    DeleteModel.confirmDeleteInquiry({
      title: "Are you sure?",
      text: "You want to delete this User permanently? ",
      isMobile,
    }).then(response => {
      if (response == true) {
        deleteApi(`User/delete-user?id=${id}`).then(({ data, status }) => {
          setIsLoading(true)
          if (status === 200) {
            toast.success("successfully deleted ", {
              style: {
                fontSize: "15px",
              },
            })
            setIsLoading(false)
            const updatedArray = tableData
              .map(obj => (obj.Id !== id ? obj : null))
              .filter(Boolean)
            setTableData(updatedArray)
          } else {
            setIsLoading(false)
            toast.error(data, {
              style: {
                fontSize: "15px",
              },
            })
          }
        })
      } else {
        setIsLoading(false)
        // ErrorModel.errormodel({
        //   title: "Verify User",
        //   text: "",
        // })
      }
    })
  }

  // user edit handle
  const handleEdit = Id => {
    if (Id) {
      navigate(routes.userUpdate, {
        state: {
          Id,
        },
      })
    }
  }

  // user active/inactive switch hanlde
  const handleSwitch = async id => {
    putApi("User/active-user", { id: String(id) }).then(({ data, status }) => {
      if (status === 200) {
        toast.success("Sucessfully Changed", {
          style: {
            fontSize: "15px",
          },
        })
      } else {
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
        userList()
      }
    })
  }

  const timeFormate = time => {
    const date = new Date(time)
    const formattedTime = date.toLocaleString("en-IN", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    })
    return formattedTime
  }

  // handle user click
  const handleUserClicks = () => {
    navigate(routes.userCreate)
  }

  const handleChangePassword = userId => {
    if (userId) {
      setUserId(userId)
    }
    setModal(!modal)
    validation.handleReset()
  }

  const toggle = () => {
    setModal1(!modal1)
  }

  const handleSubscription = (Username, userId) => {
    if (Username) {
      setUsername(Username || '')
      setUserId(userId)
    }
    toggle()
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      NewPassword: "",
      ConfirmPassword: "",
    },
    validationSchema: Yup.object({
      NewPassword: Yup.string().required("The new password is required"),
      ConfirmPassword: Yup.string()
        .required("The confirm password is required")
        .oneOf([Yup.ref("NewPassword")], "Passwords must match"),
    }),
    onSubmit: values => {
      if (values) {
        setscreeLoad(true)
        DeleteModel.confirmDeleteInquiry({
          title: "Are you sure? ",
          text: "You want to update password this user? ",
          isMobile,
        }).then(response => {
          if (response == true) {
            putApi("User/update-password", {
              userId: userId,
              newPassword: values.ConfirmPassword,
            }).then(({ data, status }) => {
              if (status == 400) {
                toast.error(data, {
                  style: {
                    fontSize: "15px",
                  },
                })
              } else {
                toast.success("successfully updated", {
                  style: {
                    fontSize: "15px",
                  },
                })
                setModal(false)
              }
              setscreeLoad(false)
            })
          } else {
            setscreeLoad(false)
            setModal(true)
          }
        })
      }
    },
  })

  const handleDownloadPdf = async id => {
    setscreeLoad(true)
    const html = await UserInvoicePdf(id, getApi)

    const doc = new jsPDF({
      format: "a5",
      unit: "px",
      filters: ["ASCIIHexEncode"],
      compress: true,
    })
    // var imgData = "data:image/jpeg;base64," + imagebase64
    doc.addFileToVFS("NotoSansGujarati-Regular.ttf", UserFont)
    doc.addFont(
      "NotoSansGujarati-Regular.ttf",
      "NotoSansGujarati-Regular",
      "normal"
    )
    doc.setFont("NotoSansGujarati-Regular") // set font
    doc.html(html, {
      async callback(doc) {
        await doc.save("invode.pdf")
      },
      margin: [10, 10, 10, 10],
    })
    setscreeLoad(false)
  }

  const whatapp = (num, username, Password) => {
    window.open(
      `https://wa.me/+91${num}?text=${encodeURIComponent(`
        *Shop Manager* \nUsername: ${username}\nPassword: ${Password} \nLogin URL: https://shop.whitecoretechnology.com/`
      )}`,
      "_blank",
      "width=1000,height=600,menubar=no,toolbar=no"
    );
  }

  const handleEncrptdata = async () => {
    localStorage.setItem("BacktoLogin", await encryptData(JSON.stringify({ backToLogin: true })))
  };

  const login = async (username, password) => {
    postApi("User/login", {
      username: username,
      password: password,
    }).then(async ({ data, status }) => {
      if (status == 200) {
        localStorage.setItem("authUser", JSON.stringify(data))
        localStorage.setItem("ShopName", data.ShopName)
        handleEncrptdata()
        navigate(routes.dashboard, {
          state: {
            backToLogin: true,
            Id: adminId
          },
        })
        location.reload()

      } else {
        setscreeLoad(false)
        toast.error(data, {
          style: {
            fontSize: "15px",
          },
        })
      }
    })
  }

  // table accessor & header
  const columns = useMemo(
    () => [
      {
        Header: "Role",
        accessor: "RoleName",
        width: 12,
      },
      {
        Header: "Username",
        accessor: "Username",
      },
      {
        Header: "Full Name",
        accessor: "FullName",
      },
      {
        Header: "Contact No.",
        accessor: "ContactNo",
        width: "7%",
      },
      {
        Header: "Shop Name",
        accessor: "ShopName",
      },
      {
        Header: "Address",
        accessor: "Address",
        Cell: ({ row }) => (
          <p
            className="mb-0"
            data-toggle="tooltip"
            data-placement="bottom"
            title={`${row.original.Address}`}
          >
            {row.original.Address.length > 15
              ? `${row.original.Address.substr(0, 15)}...`
              : row.original.Address == ""
                ? "N/A"
                : row.original.Address}
          </p>
        ),
      },
      {
        Header: "Last Login",
        accessor: "LastLoginDate",
        width: "8%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.LastLoginDate == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(
                row.original.LastLoginDate.split("T")[0],
                "dd/MM/yyyy"
              ) + ` ${timeFormate(row.original.LastLoginDate)}`}
          </p>
        ),
      },
      {
        Header: "Create Date",
        accessor: "CreatedOn",
        width: "7%",
        Cell: ({ row }) => (
          <p className=" mb-0">
            {row.original.CreatedOn == "0001-01-01T00:00:00"
              ? "N/A"
              : dateFormat(row.original.CreatedOn.split("T")[0], "dd/MM/yyyy")}
          </p>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Is Active
          </div>
        ),
        width: "6%",
        accessor: "IsActive",
        Cell: ({ row }) => (
          <FormGroup switch className="d-flex justify-content-center">
            <Input
              type="switch"
              defaultChecked={row.original.IsActive}
              onClick={e => {
                handleSwitch(row.original.Id)
              }}
            />
          </FormGroup>
        ),
      },
      {
        Header: () => (
          <div
            style={{
              textAlign: "center",
            }}
          >
            Action
          </div>
        ),
        width: "6%",
        accessor: "action",
        disableFilters: true,
        Cell: ({ row }) => {
          return (
            <ul className="list-unstyled hstack gap-1 mb-0 d-flex justify-content-center gap-2">
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-unlock-alt "
                  style={{ color: "#90499c", cursor: "pointer" }}
                  id={`changepasswordtooltip${row.original.Id}`}
                  onClick={() => handleChangePassword(row.original.Id)}
                ></i>
                <span className="mytext">Change Password</span>
              </li>
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-exchange-alt"
                  style={{ color: "blue", cursor: "pointer", display: "none" }}
                  onClick={() =>
                    login(row.original.Username, row.original.Password)
                  }
                ></i>
                <span className="mytext">Login</span>
              </li>
              <li className="mytooltip">
                <i
                  className=" fs-6 fas fa-edit btn-edit "
                  id={`edittooltip${row.original.Id}`}
                  onClick={() => handleEdit(row.original.Id)}
                ></i>
                <span className="mytext">Edit</span>
              </li>
              <li className="mytooltip">
                <i
                  className="fs-6 fas fa-trash-alt btn-delete"
                  id={`deletetooltip${row.original.Id}`}
                  onClick={() => handleDelete(row.original.Id)}
                ></i>
                <span className="mytext">Delete</span>
              </li>
            </ul>
          )
        },
      },
    ],
    [tableData]
  )

  //meta title
  document.title = `Users | ${localStorage.getItem("ShopName")}`

  return (
    <div className="page-content">
      <div className="container-fluid">
        {screeLoad && (
          <div className="loading-overlay is-active">
            <span className="fas fa-spinner fa-3x fa-spin"></span>
          </div>
        )}
        <Breadcrumbs
          title={breadcrumbs[pathname].parent}
          breadcrumbItem={breadcrumbs[pathname].breadcrumbItem}
          link={breadcrumbs[pathname].parentLink}
        />
        <Card>
          <CardBody>
            <TableContainer
              columns={columns}
              data={tableData}
              isGlobalFilter={true}
              isAddUserList={true}
              handleUserClick={handleUserClicks}
              customPageSize={20}
              className="custom-header-css"
              isLoading={isLoading}
              filterData={filterData}
              pagePerSize={pagePerSize}
              TotalRecords={TotalRecords}
            />
          </CardBody>

          <Modal
            isOpen={modal}
            toggle={() => setModal(!modal)}
            centered={true}
            size="small"
            style={{ width: "350px" }}
          >
            <div className="modal-content">
              <ModalHeader toggle={() => setModal(!modal)} tag="h5">
                Change Password
              </ModalHeader>
              <ModalBody>
                <Form
                  onSubmit={e => {
                    e.preventDefault()
                    validation.handleSubmit()
                    return false
                  }}
                  onReset={e => {
                    e.preventDefault
                    validation.handleReset()
                    return false
                  }}
                >
                  <FormGroup className="mb-2">
                    <Label htmlFor="validationCustom03" className="required">
                      New Password
                    </Label>
                    <Input
                      name="NewPassword"
                      placeholder="New Password"
                      type="password"
                      className="form-control-sm"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      value={validation.values.NewPassword || ""}
                      invalid={
                        validation.touched.NewPassword &&
                          validation.errors.NewPassword
                          ? true
                          : false
                      }
                    />
                    {validation.touched.NewPassword &&
                      validation.errors.NewPassword ? (
                      <FormFeedback type="invalid">
                        {validation.errors.NewPassword}
                      </FormFeedback>
                    ) : null}
                  </FormGroup>
                  <Label htmlFor="validationCustom03" className="required">
                    Confirm Password
                  </Label>
                  <InputGroup className="mb-2">
                    <Input
                      className="form-control-sm"
                      name="ConfirmPassword"
                      value={validation.values.ConfirmPassword || ""}
                      type={passwordShow ? "text" : "password"}
                      placeholder="Confirm Password"
                      onChange={validation.handleChange}
                      onBlur={validation.handleBlur}
                      invalid={
                        validation.touched.ConfirmPassword &&
                        !!validation.errors.ConfirmPassword
                      }
                    />
                    {/* <InputGroupAddon addonType="append"> */}
                    <Button
                      onClick={() => setPasswordShow(!passwordShow)}
                      className="btn btn-sm"
                      style={{ border: "1px solid #ced4da" }}
                      color="light"
                    >
                      {passwordShow ? (
                        <i className="mdi mdi-eye-outline" />
                      ) : (
                        <i className="mdi mdi-eye-off-outline" />
                      )}
                    </Button>
                    {/* </InputGroupAddon> */}
                    {validation.touched.ConfirmPassword &&
                      validation.errors.ConfirmPassword ? (
                      <FormFeedback type="invalid">
                        {validation.errors.ConfirmPassword}
                      </FormFeedback>
                    ) : null}
                  </InputGroup>

                  <div className="text-end">
                    <>
                      {/* {formSumitLoading ? ( */}
                      {/* <button
                      type="button"
                      className="btn btn-primary btn-sm"
                    >
                      <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                      Loading
                    </button> */}
                      {/* ) : ( */}
                      <Button
                        color="primary"
                        className="btn btn-primary btn-sm "
                        type="submit"
                      >
                        Submit
                      </Button>
                      {/* )} */}
                    </>
                  </div>
                </Form>
              </ModalBody>
            </div>
          </Modal>
          <SubscriptionModel
            modal={modal1}
            toggle={toggle}
            userListApi={userList}
            username={username}
            subscriptionUserId={userId}
            rolename={rolename}
          />
        </Card>
      </div>
    </div>
  )
}

DatatableTables.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
}

export default DatatableTables
